import { Dialog as RDialog } from 'radix-ui';
import type { ReactNode } from 'react';
import { useIsPhone } from '@/lib/use-media';
import { cn } from '@/lib/utils';
import { SheetContent } from './sheet';

export const Dialog = RDialog.Root;
export const DialogTrigger = RDialog.Trigger;
export const DialogClose = RDialog.Close;

export function DialogContent({
  title,
  description,
  children,
  className,
  footer,
}: {
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  className?: string;
  footer?: ReactNode;
}) {
  const phone = useIsPhone();
  if (phone)
    return (
      <SheetContent title={title} description={description} className={className} footer={footer}>
        {children}
      </SheetContent>
    );
  return (
    <RDialog.Portal>
      <RDialog.Overlay className="fixed inset-0 z-50 bg-[var(--overlay)] backdrop-blur-[2px]" />
      <RDialog.Content
        className={cn(
          'fixed top-1/2 left-1/2 z-50 flex max-h-[90dvh] w-[calc(100vw-24px)] max-w-lg -translate-x-1/2 -translate-y-1/2 flex-col',
          'rounded-xl border border-border bg-bg shadow-pop focus:outline-none',
          className,
        )}
      >
        <div className="flex items-center justify-between px-4 pt-3.5 pb-1">
          <RDialog.Title className="text-base font-semibold">{title}</RDialog.Title>
          <RDialog.Close
            className="inline-flex h-7 min-w-7 items-center justify-center rounded-md text-muted hover:bg-hover hover:text-fg"
            aria-label="Close"
          >
            ✕
          </RDialog.Close>
        </div>
        {description ? (
          <RDialog.Description className="px-4 text-sm text-muted">{description}</RDialog.Description>
        ) : (
          <RDialog.Description className="sr-only">{title}</RDialog.Description>
        )}
        <div className="overflow-y-auto px-4 py-3">{children}</div>
        {footer ? (
          <div className="flex justify-end gap-2 border-t border-border px-4 py-3">{footer}</div>
        ) : null}
      </RDialog.Content>
    </RDialog.Portal>
  );
}
